import {get } from '../request/http'

export const contact = p => get('reg/contactus', p);